import { Accordion as AccordionRoot } from './Accordion';
import { AccordionItem } from './Item/AccordionItem';

export const Accordion = Object.assign(AccordionRoot, {
  Item: AccordionItem,
});
